import { InboxIcon, PaperAirplaneIcon, TrashIcon, UserCircleIcon } from "@heroicons/react/24/outline";
import { yupResolver } from "@hookform/resolvers/yup";
import { FC, useEffect } from "react";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import logoImg from "../../../assets/images/logo.jpeg";
import {
  ButtonPrimary,
  FloatInput
} from "../../../components";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { clearState, forgotPassword } from "../services/AuthSlice";
import { ArrowPathIcon, ForwardIcon, XCircleIcon } from "@heroicons/react/24/solid";


export interface PageForgotPasswordProps {
  className?: string;
}

type ForgotPasswordForm = {
  Email: string;
};

const ForgotPassword: FC<PageForgotPasswordProps> = ({ className = "" }) => {
  const dispatch = useAppDispatch();

  const { isForgotPasswordSuccess, isError, isFetching, errorMessage } =
    useAppSelector((state) => state.auth);

  const validationSchema = Yup.object().shape({
    Email: Yup.string().email("Format email tidak diizinkan").required("Email is required"),
  });

  const {
    getValues,
    register,
    handleSubmit,
    // reset,
    formState: { errors },
  } = useForm<ForgotPasswordForm>({
    resolver: yupResolver(validationSchema),
  });

  useEffect(() => {


  }, []);

  const doForgotPassword = (data: ForgotPasswordForm) => {
    dispatch(
      forgotPassword({
        body: {
          FORGOT_PASSWORD: {
            Email: data.Email,
          },
        },
        headers: {
          "X-System-Auth": ""
        }
      })
    );
  }

  const renderForm = () => {
    return (
      <>
        <p className="text-sm font-bold text-gray-500 mt-8">
          Lupa kata sandi ?
        </p>
        <p className="text-sm font-normal text-gray-500 mb-5">
          verifikasi akun kamu melalui email
        </p>

        <div className="mb-2"></div>
        <FloatInput
          Icon={UserCircleIcon}
          type="text"
          label="Email / Username"
          id="email"
          {...register("Email")}
          isError={errors.Email}
          errorMessage={errors.Email?.message}
        />
        {isError && (
          <>
            <div className="mb-2"></div>
            <div
              className="p-1 text-xs rounded-full bg-red-300 items-center text-gray-800 leading-none lg:rounded-full flex lg:inline-flex"
              role="alert">
              <span className="flex mr-3">
                <XCircleIcon className="w-5 text-red-500" />
              </span>
              <span className="font-semibold mr-2 text-left flex-auto">
                Email tidak terdaftar
              </span>
            </div>
          </>
        )}
        <div className="mb-6"></div>
        <ButtonPrimary
          loading={isFetching}
          className="w-full"
          type="submit"
        >
          kirim verifikasi lewat email
          <PaperAirplaneIcon className="ml-4 w-5" />
        </ButtonPrimary>
      </>
    )
  }

  return (
    <div className={`nc-PageForgotPassword bg-gray-100 ${className}`} data-nc-id="PageForgotPassword">
      <div className="container h-screen flex w-full justify-center">
        <div className="flex w-full lg:w-1/2 justify-center items-center ">
          <div className="w-full md:px-32 lg:px-24">

            <form
              onSubmit={handleSubmit(doForgotPassword)}
              className="bg-white rounded-md shadow-2xl p-3 md:p-5 -mt-40">
              <div className="w-full flex flex-row justify-start space-x-5 items-center">
                <img
                  className={`block max-h-16`}
                  src={logoImg}
                  alt="Logo"
                />
              </div>
              {/* <h1 className="text-gray-600 font-bold text-2xl">
                Selamat Datang
              </h1>*/}

              {
                isForgotPasswordSuccess ?
                  <>
                    <h1 className="mt-10 text-gray-600 text-sm md:text-md leading-4 md:leading-5 w-full flex flex-col justify-start items-start">
                      <span>
                        Verifikasi berhasil dikirim ke
                      </span>
                    </h1>
                    <h1 className=" text-gray-600 text-sm md:text-xl leading-4 md:leading-5 w-full flex flex-col justify-start items-start">
                      <span>
                        <span className="font-semibold">{getValues("Email")}</span>
                      </span>
                    </h1>

                    <h1 className="flex flex-row mt-5 mb-5 text-gray-600 text-sm md:text-md leading-4 md:leading-5 w-full">
                      Check pesan masuk <InboxIcon className="w-5 text-purple-600 mx-3" /> atau spam <TrashIcon className="w-5 text-purple-600 ml-3" />
                    </h1>

                    <ButtonPrimary
                      className="w-full"
                      type="button"
                      onClick={() => {
                        dispatch(clearState({}))
                      }}
                    >
                      kirim ulang
                      <ArrowPathIcon className="ml-5 w-5" />
                    </ButtonPrimary>
                  </>
                  :
                  <>
                    {renderForm()}
                  </>
              }


              {/* {
                isFetchingAuthSystem ? <>
                  {clientAccess()}
                </> : <>
                  {
                    client ? <> {
                      isAuth ? <>
                        <h1 className="mt-10 text-gray-600 text-sm md:text-xl leading-4 md:leading-5 w-full flex flex-col justify-start items-start">
                          <span>
                            Hi, <span className="font-semibold">{profile?.email_addr}</span>
                          </span>
                          <div className="my-4"></div>
                          <div className="flex flex-row space-x-3 w-full">
                            <ButtonPrimary
                              loading={isFetching}
                              className="w-full"
                              type="button"
                              onClick={() => doSelanjutnnyya()}
                            >
                              Selanjutnya <ArrowRightOnRectangleIcon className="font-bold ml-5 w-6" />
                            </ButtonPrimary>
                          </div>
                        </h1>
                      </>
                        :
                        <> {renderForm()}</>
                    }
                    </> : <>
                      {clientReject()}
                    </>
                  }
                </>
              } */}

            </form>
          </div>
        </div>
      </div>
    </div>
  );


};

export default ForgotPassword;
